import { render, staticRenderFns } from "./debt-ledger.vue?vue&type=template&id=00366fa4&"
import script from "./debt-ledger.vue?vue&type=script&lang=js&"
export * from "./debt-ledger.vue?vue&type=script&lang=js&"
import style0 from "./debt-ledger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports